import { Box } from '@mui/material';
import React, { createContext, useCallback, useEffect, useState } from 'react';

import PageHeader from '@/components/PageHeader/index';
import client from '@/lib/feathers';
import AccountingSubject from '@/types/database/accountingSubject';

import FinanceFunc from './FinanceFunc/index';
import PaymentList from './PaymentList/index';

export const FinanceDataContext = createContext<{
  accountingSubjects: AccountingSubject[];
  setAccountingSubjects: React.Dispatch<
    React.SetStateAction<AccountingSubject[]>
  >;
  householdNumbers: string[];
  setHouseholdNumbers: React.Dispatch<React.SetStateAction<string[]>>;
}>({
  accountingSubjects: [],
  setAccountingSubjects: () => {},
  householdNumbers: [],
  setHouseholdNumbers: () => {},
});

export default function Finance() {
  const [trigger, setTrigger] = useState<Record<string, never>>({});
  const [accountingSubjects, setAccountingSubjects] = useState<
    AccountingSubject[]
  >([]);
  const [householdNumbers, setHouseholdNumbers] = useState<string[]>([]);

  const getAccountingSubjects = useCallback(async () => {
    try {
      const res = await client.service('accountingSubjects').find();
      setAccountingSubjects(res.data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const getHouseholdNumbers = useCallback(async () => {
    try {
      const res = await client.service('residentAccountNumbers').find({
        query: {
          $select: ['householdNumber'],
        },
      });
      setHouseholdNumbers(
        res.data.map(
          (item: { _id: string; householdNumber: string }) =>
            item.householdNumber
        )
      );
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    getAccountingSubjects();
    getHouseholdNumbers();
  }, [getAccountingSubjects, getHouseholdNumbers]);

  return (
    <FinanceDataContext.Provider
      value={{
        accountingSubjects,
        setAccountingSubjects,
        householdNumbers,
        setHouseholdNumbers,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <PageHeader
          breadcrumbs={[{ name: '財務管理' }, { name: '住戶財務列表' }]}
          title="住戶財務列表"
        />
        <FinanceFunc {...{ trigger, setTrigger }} />
        <PaymentList {...{ trigger, setTrigger }} />
      </Box>
    </FinanceDataContext.Provider>
  );
}
